import { Component, Vue, Prop as prop, Prop} from 'nuxt-property-decorator';

@Component
export default class ConfiguratorImageRow extends Vue {

    @Prop() option;
    @Prop() current;
    @Prop() item;


    get imagePath() {

        let image = this.option.image;

        if (!image) {
            return;
        }
    
        if (image.startsWith('upload')) {
            image = image.substring(6);
        }
    
        image += '.x1.' + this.$store.state.imageFormat;
    
        return image;
    }
}
